import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { dismissNotification, type SnackbarKey } from "@utils/notification.ts";

export const AppSnackbarCloseButton = ({
  snackbarKey,
}: {
  snackbarKey: SnackbarKey;
}) => {
  return (
    <IconButton onClick={() => dismissNotification(snackbarKey)}>
      <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
    </IconButton>
  );
};
